export default __webpack_public_path__ + "static/media/kids_with_phone_2.87e1824b.jpg";